var ConstantObject = {};

ConstantObject.host = 'http://srigurugranthsahib.org/';
//ConstantObject.host = 'http://sri.local/';

ConstantObject.imagelist_json = ConstantObject.host + 'quotes/imagelist2.json';
ConstantObject.imagesizes_json =   ConstantObject.host + 'quotes/imagesizes2.json';
ConstantObject.quotes_script_root = ConstantObject.host + 'quotes/';
ConstantObject.quotes_img_root =   ConstantObject.host + 'quotes/img/';
ConstantObject.quotes_img_sizes_root =   ConstantObject.host + 'quotes/img-sizes/';

ConstantObject.delayLeft = '0.3s';
ConstantObject.delayOpacity = '0.3s';
ConstantObject.getbachansurl = ConstantObject.host + 'quotes/getbachans.php?token=aabbgg';
//ConstantObject.getbachansurl = 'http://www.srigurugranthsahib.org/quotes/getbachans.php?token=aabbgg';

Object.freeze(ConstantObject)

export default ConstantObject;
